import React from "react";
import {
  Box,
  Card,
  Grid,
  Skeleton,
  Stack,
} from "@mui/material";

function PaymentDashboardSkeleton() {
  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      {/* Greeting Section */}
      <Stack spacing={1} sx={{ mb: 4 }}>
        <Skeleton variant="text" width={220} height={40} />
        <Skeleton variant="text" width={300} height={24} />
      </Stack>

      {/* Balance Card */}
      <Card sx={{ p: 3, mb: 4 }}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={6}>
            <Skeleton width={90} height={20} />
            <Skeleton width={200} height={44} />
            <Skeleton width={280} height={18} />
          </Grid>

          <Grid item xs={12} md={6}>
            <Skeleton width={220} height={20} />
            <Skeleton width={160} height={28} />
          </Grid>
        </Grid>
      </Card>

      {/* Payment Plan Header */}
      <Skeleton variant="text" width={260} height={32} sx={{ mb: 2 }} />

      {/* Payment Plan Options */}
      <Grid container spacing={2} sx={{ mb: 4 }}>
        {[1, 2, 3, 4].map((item) => (
          <Grid item xs={12} md={6} key={item}>
            <Card sx={{ p: 2 }}>
              <Grid container spacing={2} alignItems="center">
                <Grid item>
                  <Skeleton
                    variant="circular"
                    width={40}
                    height={40}
                  />
                </Grid>
                <Grid item xs>
                  <Skeleton width="65%" height={22} />
                  <Skeleton width="85%" height={18} />
                </Grid>
              </Grid>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Configuration Section */}
      <Card sx={{ p: 3, mb: 4 }}>
        <Skeleton width={280} height={26} sx={{ mb: 2 }} />

        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Skeleton height={56} />
          </Grid>
          <Grid item xs={12} md={4}>
            <Skeleton height={56} />
          </Grid>
          <Grid item xs={12} md={4}>
            <Skeleton height={56} />
          </Grid>
        </Grid>

        <Skeleton width={220} height={44} sx={{ mt: 3 }} />
      </Card>

      {/* Schedule Table */}
      <Card sx={{ p: 3, mb: 4 }}>
        <Skeleton width={200} height={24} sx={{ mb: 2 }} />
        {[1, 2, 3, 4].map((row) => (
          <Skeleton key={row} height={32} sx={{ mb: 1 }} />
        ))}
        <Skeleton height={40} />
      </Card>

      {/* Sticky Proceed Bar */}
      <Box
        sx={{
          position: "sticky",
          bottom: 0,
          backgroundColor: "background.paper",
          p: 2,
          borderTop: "1px solid #e0e0e0",
        }}
      >
        <Grid container justifyContent="flex-end">
          <Skeleton
            variant="rectangular"
            width={180}
            height={44}
            animation="wave"
          />
        </Grid>
      </Box>
    </Box>
  );
}

export default PaymentDashboardSkeleton;